var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3323(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.032,
    height: 25.166,
    viewBox: "0 0 31.032 25.166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3323",
    "data-name": "Group 3323",
    transform: "translate(-1229.788 -328.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(1228.638 325.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2700",
    "data-name": "Group 2700",
    transform: "translate(1.15 3.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M4.039,3.15H20.26A2.893,2.893,0,0,1,23.15,6.039V18.205a2.893,2.893,0,0,1-2.889,2.889H4.039A2.893,2.893,0,0,1,1.15,18.205V6.039A2.893,2.893,0,0,1,4.039,3.15ZM20.26,19.371a1.167,1.167,0,0,0,1.166-1.166V6.039A1.167,1.167,0,0,0,20.26,4.873H4.039A1.167,1.167,0,0,0,2.873,6.039V18.205a1.167,1.167,0,0,0,1.166,1.166Z",
    transform: "translate(-1.15 -3.15)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M12.15,13.85a.869.869,0,0,1-.494-.154L1.518,6.7a.843.843,0,0,1-.212-1.184.869.869,0,0,1,1.2-.209l9.644,6.659L21.794,5.3a.869.869,0,0,1,1.2.209A.843.843,0,0,1,22.782,6.7l-10.138,7A.869.869,0,0,1,12.15,13.85Z",
    transform: "translate(-1.15 -3.15)",
    fill: "#212121"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1275",
    "data-name": "Group 1275",
    transform: "translate(1244.755 338.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M332.167,260.868a8.032,8.032,0,1,1-8.032-8.032,8.032,8.032,0,0,1,8.032,8.032",
    transform: "translate(-316.102 -252.836)",
    fill: "#95a7c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M398.4,327.441h-2.624v-2.953a.636.636,0,1,0-1.267,0v2.953h-2.624a.7.7,0,0,0,0,1.392h2.624v2.816a.636.636,0,1,0,1.267,0v-2.816H398.4a.7.7,0,0,0,0-1.392",
    transform: "translate(-386.877 -320.047)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3323);
export default __webpack_public_path__ + "static/media/Group 3323.ff79d702954d65781f034e27cc789563.svg";
export { ForwardRef as ReactComponent };